module.exports = __webpack_public_path__ + "img/hat.wolf.8410e233.png";